import baseUrl from '../baseUrl/baseUrl';
import { Request, requestNoToken } from '../utils';

export const login = async (data) => {
  const result = await requestNoToken.post('login', data);
  return result;
};

export const tokenRefresh = async () => {
  const result = await Request.get('users/refresh-token');
  return result;
};
export const saveUserAgrementResposne = async (data) => {
  const result = await Request.post('/user-agreement-permission', data);
  return result;
};
export const getTecoAdviceUserAgreement = async () => {
  const result = await Request.get('/user-agreement/TECO-ADVISE');
  return result;
};
export const getUserInfo = async (token) => {
  const result = await Request.get('/users', {}, {}, baseUrl.tecoPath, token);
  return result;
};